import { PuzzleGameModel } from './puzzle-game.model';
import {
  LetterDeleteRestrictions,
  LetterOverwriteRestrictions,
  WordJumpOnRestrictions,
  WordJumpToRestrictions,
  DarkModes,
} from './puzzle-game-state.model';

export class InitPuzzleGame {
  static readonly type = '[PuzzleGame] Init';
  constructor(public payload: PuzzleGameModel) {
    payload.moveCounter = 0;
    payload.finished = false;
    payload.started = false;
    payload.hideShowSolutionDialog = false;
  }
}

export class SetPuzzleGame {
  static readonly type = '[PuzzleGame] Set';
  constructor(public payload: PuzzleGameModel) {}
}

// export class PuzzleGameMultiTabSync {
//   static readonly type = '[PuzzleGame] Sync browser tabs';
//   constructor(public payload: { [puzzleID: string]: PuzzleGameModel }) {}
// }

export class PuzzleGameAction {
  constructor(public payload: { puzzleID: string }) {}
  public preventUpdate = false;
}

export class DontShowSolutionDialogAgain extends PuzzleGameAction {
  static readonly type = '[PuzzleGame] Dont show show-solution-dialog again';
}

export class IncMoveCounter extends PuzzleGameAction {
  static readonly type = '[PuzzleGame] Increment moveCounter';
}

export class SetGameProgress {
  constructor(public payload: { puzzleID: string; progress: number }) {}
  static readonly type = '[PuzzleGame] Set progress';
}

export class SetGameDifficulty {
  constructor(public payload: { difficulty: string }) {}
  static readonly type = '[PuzzleGame] Set difficulty';
}

export class SetLanguage {
  constructor(public payload: { language: string }) {}
  static readonly type = '[PuzzleGame] Set language';
}

export class UpdateTime extends PuzzleGameAction {
  static readonly type = '[PuzzleGame] Update time';
}

export class InitTime extends PuzzleGameAction {
  static readonly type = '[PuzzleGame] Init time';
}

export class ConsumeJoker extends PuzzleGameAction {
  static readonly type = '[PuzzleGame] Consume Joker';
}

export class SetFinished extends PuzzleGameAction {
  static readonly type = '[PuzzleGame] Set finished';
}

export class FoundSolutionWord extends PuzzleGameAction {
  static readonly type = '[PuzzleGame] Found solution word';
}

export class FoundSaying extends PuzzleGameAction {
  static readonly type = '[PuzzleGame] Found saying';
}

export class StartGame extends PuzzleGameAction {
  static readonly type = '[PuzzleGame] Start game';
}

export class PauseGame extends PuzzleGameAction {
  static readonly type = '[PuzzleGame] Pause game';
}

export class ResetPause extends PuzzleGameAction {
  static readonly type = '[PuzzleGame] Reset pause';
}

export class ResumeGame extends PuzzleGameAction {
  static readonly type = '[PuzzleGame] Resume game';
}

export class SetAutoZoomEnabled {
  constructor(public payload: { autoZoomEnabled: boolean }) {}
  static readonly type = '[PuzzleGame] Set autoZoomEnabled';
}

export class SetLetterDeleteRestriction {
  constructor(public payload: { letterDeleteRestriction: LetterDeleteRestrictions }) {}
  static readonly type = '[PuzzleGame] Set letterDeleteRestriction';
}

export class SetLetterOverwriteRestriction {
  constructor(public payload: { letterOverwriteRestriction: LetterOverwriteRestrictions }) {}
  static readonly type = '[PuzzleGame] Set letterOverwriteRestriction';
}

export class SetSkipFilledFieldsEnabled {
  constructor(public payload: { skipFilledFieldsEnabled: boolean }) {}
  static readonly type = '[PuzzleGame] Set skipFilledFieldsEnabled';
}

export class SetWordJumpOnRestriction {
  constructor(public payload: { wordJumpOnRestriction: WordJumpOnRestrictions }) {}
  static readonly type = '[PuzzleGame] Set wordJumpOnRestriction';
}

export class SetWordJumpToRestriction {
  constructor(public payload: { wordJumpToRestriction: WordJumpToRestrictions }) {}
  static readonly type = '[PuzzleGame] Set wordJumpToRestriction';
}

export class SetWordJumpEnabled {
  constructor(public payload: { wordJumpEnabled: boolean }) {}
  static readonly type = '[PuzzleGame] Set wordJumpEnabled';
}

export class SetAutoMoveEnabled {
  constructor(public payload: { autoMoveEnabled: boolean }) {}
  static readonly type = '[PuzzleGame] Set autoMoveEnabled';
}

export class SetDefinitionBarEnabled {
  constructor(public payload: { definitionBarEnabled: boolean }) {}
  static readonly type = '[PuzzleGame] Set definitionBarEnabled';
}

export class SetNativeKeyboardEnabled {
  constructor(public payload: { nativeKeyboardEnabled: boolean }) {}
  static readonly type = '[PuzzleGame] Set nativeKeyboardEnabled';
}

export class SetKeepKeyboardOpen {
  constructor(public payload: { keepKeyboardOpen: boolean }) {}
  static readonly type = '[PuzzleGame] Set keepKeyboardOpen';
}

export class SetHighlightRightAndWrongEnabled {
  constructor(public payload: { highlightRightAndWrongEnabled: boolean }) {}
  static readonly type = '[PuzzleGame] Set highlightRightAndWrongEnabled';
}

export class SetShowErrorsImmediately {
  constructor(public payload: { showErrorsImmediately: boolean }) {}
  static readonly type = '[PuzzleGame] Set showErrorsImmediately';
}

export class SetDarkMode {
  constructor(public payload: { darkMode: DarkModes }) {}
  static readonly type = '[PuzzleGame] Set darkMode';
}

export class SetDarkModeEnabled {
  constructor(public payload: { darkModeEnabled: boolean }) {}
  static readonly type = '[PuzzleGame] Set darkModeEnabled';
}

export class SetHighContrastEnabled {
  constructor(public payload: { highContrastEnabled: boolean }) {}
  static readonly type = '[PuzzleGame] Set highContrastEnabled';
}

export class InitDefaultValuesFromConfig {
  static readonly type = '[PuzzleGame] Init default';

  constructor(
    public payload: {
      autoZoomEnabled: boolean;
      nativeKeyboardEnabled: boolean;
      reset: boolean;
      definitionBarEnabled: boolean;
      keepKeyboardOpen: boolean;
      highlightRightAndWrongEnabled: boolean;
      showErrorsImmediately: boolean;
      wordJumpOnRestriction: WordJumpOnRestrictions;
      wordJumpToRestriction: WordJumpToRestrictions;
    }
  ) {}
}

export class ResetLetterSkipSettings {
  static readonly type = '[PuzzleGame] Reset letter skipping';
}

export class ResetLetterSkipSettingsForLeaderboard {
  static readonly type = '[PuzzleGame] Reset letter skipping for leaderboard mode';
}
